import { useNavigate } from "react-router-dom";
import "./Home.css";

export default function VyraHome() {
  const navigate = useNavigate();

  return (
    <div className="home">
      <section className="hero">
        <div className="hero-bg-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-trust-bar">
              <span className="trust-item">
                <span className="trust-icon">✓</span> WHO-GMP Certified
              </span>
              <span className="trust-divider"></span>
              <span className="trust-item">
                <span className="trust-icon">✓</span> 19+ Products
              </span>
              <span className="trust-divider"></span>
              <span className="trust-item">
                <span className="trust-icon">✓</span> Pan-India Delivery
              </span>
            </div>
            <h1>
              Advancing Healthcare with <span className="highlight">Quality Medicines</span>
            </h1>
            <p className="hero-subtitle">
              Vyra Pharma delivers trusted pharmaceutical solutions across multiple therapeutic segments — built on innovation, safety, and affordability.
            </p>
            <p className="hero-desc">
              From hematinics to nutraceuticals, our WHO-GMP certified formulations are designed to improve patient outcomes and support healthcare professionals nationwide.
            </p>
            <div className="hero-buttons">
              <button className="btn btn-primary btn-lg" onClick={() => navigate("/products")}>
                Explore Products
              </button>
              <button className="btn btn-outline btn-lg" onClick={() => navigate("/contact")}>
                Partner With Us
              </button>
            </div>
            <div className="hero-scroll-indicator">
              <span>Scroll to explore</span>
              <div className="scroll-mouse">
                <div className="scroll-wheel"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <h3>19+</h3>
              <p>Products</p>
            </div>
            <div className="stat-card">
              <h3>10+</h3>
              <p>Distributors</p>
            </div>
            <div className="stat-card">
              <h3>10+</h3>
              <p>Therapy Areas</p>
            </div>
            <div className="stat-card">
              <h3>WHO-GMP</h3>
              <p>Certified</p>
            </div>
          </div>
        </div>
      </section>

      <section className="home-about">
        <div className="container">
          <div className="about-header">
            <span className="about-label">Who We Are</span>
            <h2>Building Trust Through <span className="text-gradient">Quality Healthcare</span></h2>
            <p>
              Vyra Pharma is committed to delivering high-quality pharmaceutical
              products across multiple therapeutic segments. We focus on safety,
              efficacy, and affordability to support healthcare professionals and
              patients.
            </p>
          </div>

          <div className="about-grid">
            <div className="about-features">
              <div className="feature-card">
                <div className="feature-icon">🏭</div>
                <div className="feature-content">
                  <h4>WHO-GMP Manufacturing</h4>
                  <p>State-of-the-art manufacturing facilities adhering to global quality standards and rigorous regulatory compliance.</p>
                </div>
              </div>

              <div className="feature-card">
                <div className="feature-icon">✅</div>
                <div className="feature-content">
                  <h4>Quality Assured Products</h4>
                  <p>Every batch undergoes strict quality control testing to ensure safety, efficacy, and consistency.</p>
                </div>
              </div>

              <div className="feature-card">
                <div className="feature-icon">🌐</div>
                <div className="feature-content">
                  <h4>Wide Distribution Network</h4>
                  <p>Pan-India presence with reliable logistics ensuring timely delivery to healthcare partners.</p>
                </div>
              </div>

              <div className="feature-card">
                <div className="feature-icon">💰</div>
                <div className="feature-content">
                  <h4>Affordable Pricing</h4>
                  <p>Making quality healthcare accessible through cost-effective solutions without compromising on quality.</p>
                </div>
              </div>
            </div>

            <div className="about-visual">
              <div className="visual-card">
                <div className="visual-icon">💊</div>
                <h3>19+ Products</h3>
                <p>Across 10+ therapeutic areas</p>
              </div>
              <div className="visual-card">
                <div className="visual-icon">🤝</div>
                <h3>10+ Partners</h3>
                <p>Trusted distributors nationwide</p>
              </div>
              <div className="visual-card">
                <div className="visual-icon">🏆</div>
                <h3>WHO-GMP</h3>
                <p>Certified manufacturing</p>
              </div>
            </div>
          </div>

          <div className="about-cta">
            <button className="btn btn-primary" onClick={() => navigate("/about")}>
              Learn More About Us
            </button>
          </div>
        </div>
      </section>

      <section className="therapy">
        <div className="container">
          <h2>Therapy Segments</h2>
          <p className="section-subtitle">Comprehensive healthcare solutions across diverse therapeutic areas</p>

          <div className="therapy-grid">
            <div className="therapy-card">
              <div className="therapy-icon">💊</div>
              <h4>General Range</h4>
              <p>Essential medicines for everyday health needs</p>
            </div>
            <div className="therapy-card">
              <div className="therapy-icon">👶</div>
              <h4>Pediatric</h4>
              <p>Specialized formulations for children's healthcare</p>
            </div>
            <div className="therapy-card">
              <div className="therapy-icon">🦴</div>
              <h4>Orthopedic</h4>
              <p>Bone and joint care solutions</p>
            </div>
            <div className="therapy-card">
              <div className="therapy-icon">❤️</div>
              <h4>Cardiac Diabetic</h4>
              <p>Heart and diabetes management products</p>
            </div>
            <div className="therapy-card">
              <div className="therapy-icon">🧠</div>
              <h4>Neurology</h4>
              <p>Neuropathy and nerve care formulations</p>
            </div>
            <div className="therapy-card">
              <div className="therapy-icon">🥗</div>
              <h4>Nutraceuticals</h4>
              <p>Nutritional supplements for healthy living</p>
            </div>
          </div>
        </div>
      </section>

      <section className="home-cta">
        <div className="container">
          <h2>Explore Our Complete Product Portfolio</h2>
          <p>Discover 19+ high-quality pharmaceutical products designed for better healthcare outcomes.</p>
          <button className="btn btn-secondary btn-lg" onClick={() => navigate("/products")}>
            View All Products
          </button>
        </div>
      </section>
    </div>
  );
}
